import type { SceneContent } from '../../presentation/types';

/**
 * Moderta Native: a separate Moderta brand, placed immediately after Research Space (owner
 * decisions 2026-10-10). Identity: Moderta-Native-Brand-Guidelines.pdf. The existing showcase has
 * no Native product content, so the only factual statements are the owner's role line
 * (docs/design-system/products/07-NATIVE.md) and the confirmed brand separation. Fuller service
 * copy needs owner-approved facts (the Services PDF is an identity reference, not a fact source).
 */
export const native: SceneContent = {
  id: 'native',
  shortLabel: 'NATIVE',
  title: 'Moderta Native',
  seconds: 30,
  brand: 'native',
  bridgeIn: 'Next to the platforms sits a separate Moderta brand, with its own identity.',
  atmosphere: (step) => ({ pattern: step >= 1 ? 'stream' : 'ambient', density: 0.1, opacity: 0.035, cameraZ: 14.2 }),
  script: {
    title: 'Moderta Native',
    onScreen: ['Moderta Native', 'IT consulting, specialist services and AI-native transformation.', 'IT consulting · Specialist services · AI-native transformation', 'A separate Moderta brand, with its own identity.'],
    visual: 'The stage floods Moderta Navy from the right while a large, cropped MN monogram settles as a watermark. The reversed Moderta Native logo resolves left-aligned, with a thin blue-to-pink brand-gradient rule beneath it. Three pill-shaped capabilities follow on one line with Signal Blue line icons, joined by a single rule.',
    narration: [
      'Moderta Native is the separate Moderta brand for IT consulting, specialist services and AI-native transformation.',
      'Three kinds of work under one brand: IT consulting, specialist services, and transformation towards AI-native ways of working.',
      'It is distinct from Research Space, with its own name, logo, typeface and colour.',
    ],
    presenterNotes: [
      'Navy takeover, logo resolves. Read the role line once.',
      'Three capabilities. Keep to these three words until owner-approved service copy is added.',
      '"A separate Moderta brand." Do not merge it with Research Space.',
    ],
  },
};
